(function () {
  const root = document.querySelector("[data-cbd-selector]");
  if (!root) return;

  const params = new URLSearchParams(window.location.search);
  const DEBUG = params.get("debug") === "1" || params.get("debug") === "true";
  const dlog = (...a) => DEBUG && console.log("[CBD-SELECTOR]", ...a);

  let items = Array.from(root.querySelectorAll(".cbd-selector__item"));
  const emptyEl = root.querySelector("#CbdSelectorEmpty");
  const countEl = root.querySelector("[data-count]");
  const needInput = root.querySelector("[data-need-input]");
  const intensityInput = root.querySelector("[data-intensity-input]");

  // ---------- helpers ----------
  const norm = (v) => String(v ?? "").trim().toLowerCase();

  function csvHas(csv, value) {
    const v = norm(value);
    if (!csv || !v) return false;
    return String(csv)
      .split(",")
      .map((s) => norm(s))
      .filter(Boolean)
      .includes(v);
  }

  // ---------- deduplicate ----------
  const byId = new Map();
  for (const el of items) {
    const id = el.dataset.productId;
    if (!id) continue;
    if (!byId.has(id)) byId.set(id, el);
    else el.remove();
  }
  items = Array.from(byId.values());

  // ---------- UI bindings ----------
  function bindSingleButtons(selector, hiddenInput) {
    const btns = Array.from(root.querySelectorAll(selector));
    btns.forEach((btn) => {
      btn.addEventListener("click", () => {
        btns.forEach((b) => {
          b.classList.remove("is-active");
          b.setAttribute("aria-pressed", "false");
        });
        btn.classList.add("is-active");
        btn.setAttribute("aria-pressed", "true");
        if (hiddenInput) hiddenInput.value = btn.value;
        run();
      });
    });
  }

  function bindMultiButtons(selector) {
    const btns = Array.from(root.querySelectorAll(selector));
    btns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const active = btn.classList.toggle("is-active");
        btn.setAttribute("aria-pressed", active ? "true" : "false");
        run();
      });
    });
  }

  function getActiveValues(selector) {
    return Array.from(root.querySelectorAll(selector))
      .filter((b) => b.classList.contains("is-active"))
      .map((b) => norm(b.value))
      .filter(Boolean);
  }

  bindSingleButtons("[data-need]", needInput);
  bindSingleButtons("[data-intensity]", intensityInput);
  bindMultiButtons("[data-thc]");
  bindMultiButtons("[data-famille]");

  // ---------- selection ----------
  function getSelection() {
    let need = needInput?.value ? norm(needInput.value) : "";
    let intensity = intensityInput?.value ? norm(intensityInput.value) : "moyen";

    if (intensity === "standard") intensity = "moyen";

    let thcList = getActiveValues("[data-thc]").map((v) =>
      v === "sans" ? "zero" : v
    );

    const families = getActiveValues("[data-famille]");
    return { need, intensity, thcList, families };
  }

  function matchItem(el, sel) {
    if (!sel.families.includes(norm(el.dataset.famille))) return false;
    if (!csvHas(el.dataset.needs, sel.need)) return false;
    if (!csvHas(el.dataset.intensity, sel.intensity)) return false;
    if (!sel.thcList.includes(norm(el.dataset.thc))) return false;
    return true;
  }

  function hideAll() {
    items.forEach((el) => (el.hidden = true));
  }

  // ---------- main run ----------
  function run() {
    const sel = getSelection();

    if (!sel.need || !sel.families.length || !sel.thcList.length) {
      hideAll();
      if (emptyEl) emptyEl.hidden = false;
      if (countEl) countEl.textContent = "0 produit";
      return;
    }

    let shown = 0;
    for (const el of items) {
      const ok = matchItem(el, sel);
      el.hidden = !ok;
      if (ok) shown++;
    }

    if (countEl)
      countEl.textContent = `${shown} produit${shown > 1 ? "s" : ""}`;
    if (emptyEl) emptyEl.hidden = shown !== 0;

    dlog("Selection:", sel, "shown:", shown);

    // ⭐ IMPORTANT : hydrate APRÈS repaint
    requestAnimationFrame(() => hydrateRatings(true));
  }

  // ---------- ratings ----------
  async function hydrateRatings(visibleOnly = true) {
    const nodes = Array.from(
      root.querySelectorAll("[data-rating][data-handle]")
    );

    const targets = visibleOnly
      ? nodes.filter((n) => {
          const item = n.closest(".cbd-selector__item");
          if (!item) return false;
          if (item.hidden) return false;
          if (getComputedStyle(item).display === "none") return false;
          return true;
        })
      : nodes;

    if (!targets.length) return;

    window.__cbdRatingCache = window.__cbdRatingCache || new Map();
    const cache = window.__cbdRatingCache;

    const handles = [
      ...new Set(targets.map((n) => n.dataset.handle).filter(Boolean)),
    ];

    const CONCURRENCY = 8;
    let i = 0;

    async function worker() {
      while (i < handles.length) {
        const handle = handles[i++];
        if (cache.has(handle)) continue;

        try {
          const res = await fetch(`/products/${handle}?view=rating-json`, {
            credentials: "same-origin",
          });
          if (!res.ok) throw new Error();
          cache.set(handle, await res.json());
        } catch {
          cache.set(handle, null);
        }
      }
    }

    await Promise.all(Array.from({ length: CONCURRENCY }, worker));

    for (const n of targets) {
      const data = cache.get(n.dataset.handle);
      if (!data || !data.rating || !data.count) {
        n.innerHTML = "";
        continue;
      }

      const rating = Number(data.rating);
      const count = Number(data.count);
      if (!count) continue;

      const pct = Math.min(100, (rating / 5) * 100).toFixed(1);

      n.innerHTML = `
        <div class="cbd-rating__wrap" aria-label="${rating.toFixed(1)} / 5">
          <span class="cbd-stars" style="--pct:${pct}%"></span>
          <span class="cbd-rating__count">(${count})</span>
        </div>
      `;

      // 🔁 reposition AVANT le prix (Horizon)
      const card = n.closest(".cbd-selector__item")?.querySelector("product-card");
      const content = card?.querySelector(".product-card__content");
      if (!content) continue;

      const price =
        content.querySelector("product-price") ||
        content.querySelector("[ref='priceContainer']")?.closest("product-price");

      if (price && n.parentElement !== content) {
        price.insertAdjacentElement("beforebegin", n);
      }
    }
  }

  // ---------- init ----------
  run();
  hydrateRatings(false); // précharge le cache une fois
})();


// Redimensionnement correct des blocs de texte
document.addEventListener("DOMContentLoaded", () => {
  const ids = [
    "shopify-section-template--25998596571521__section_dphgdq",
    "shopify-section-template--25998596571521__section_zrEqYj",
    "shopify-section-template--25998596571521__custom_liquid_n7YiEr"
  ];

  ids.forEach(id => {
    const section = document.getElementById(id);
    if (!section) return;

    // cas Horizon : le conteneur réel est souvent .section ou .section-resource-list
    const target =
      section.querySelector(".section") ||
      section.querySelector(".section-resource-list");

    if (target && !target.classList.contains("page-width-content")) {
      target.classList.add("page-width-content");
    }
  });
});
